// Layouts
import DashboardLayout from "./layouts/Dashboard"

// Public routes
import Login from './pages/Login'
import ResetPassword from './pages/ResetPassword'
import SendResetPasswordLink from './pages/SendResetPasswordLink'
import NotFound from './pages/NotFound'

// Dashboard routes
import Dashboard from './pages/dashboards/Home'
import ProposalDashboard from './pages/dashboards/tabs/ProposalDashboard'
import ProjectDashboard from './pages/dashboards/tabs/ProjectDashboard'
import ExpirationDashboard from './pages/dashboards/tabs/ExpirationDashboard'
import BillingDashboard from './pages/dashboards/tabs/BillingDashboard'
import JobCostingDashboard from './pages/dashboards/tabs/JobCosting'
import ProductionReport from './pages/dashboards/tabs/ProductionReport'
import ServicesOverviewReport from './pages/dashboards/tabs/ServicesOverviewReport'
import TasksByLocation from './pages/dashboards/tabs/TasksByLocation'
import ServiceLevelReport from './pages/dashboards/tabs/ServiceLevelReport'

// Users
import Users from './pages/users/Index'
import CreateUser from './pages/users/Create'
import ShowUser from './pages/users/Show'
import EditUser from './pages/users/Edit'

// Roles
import Roles from './pages/roles/Index'
import CreateRole from './pages/roles/Create'
import ShowRole from './pages/roles/Show'
import EditRole from './pages/roles/Edit'

import Teams from './pages/teams/Index'

import PageEmails from './pages/Emails'
import UserSettings from './pages/UserSettings'

// Contacts
import Companies from './pages/companies/Index'
import CreateCompany from './pages/companies/Create'
import ShowCompany from './pages/companies/Show'
import EditCompany from './pages/companies/Edit'

// Emails
import Emails from './pages/emails/Index'
import EmailsTest from './pages/emails/IndexTest'
import EmailsLogin from './pages/emails/EmailsLogin'
import ShowMail from './pages/emails/ShowMail'
import ShowMailTest from './pages/emails/ShowMailTest'

// Projects
import Projects from './pages/projects/Index'
import ShowProject from './pages/projects/Show'
import EditProject from './pages/projects/Edit'

// Slack
import Slack from './pages/slack/Index'
import SlackChannel from './modules/slack/pages/ChannelPage'
import SavedItemsPage from './modules/slack/pages/SavedItemsPage'

// Project tabs
import ProjectContacts from './pages/projects/tabs/Contacts'
import ProjectActivities from './pages/projects/tabs/Activities'
import ReferenceEmails from './pages/projects/tabs/ReferenceEmails'
import ProjectTasks from './pages/projects/tabs/Tasks'
import ProjectApplications from './pages/projects/tabs/Applications'
import ProjectNotes from './pages/projects/tabs/Notes'
import ProjectCorrespondence from './pages/projects/tabs/Correspondence'
import ProjectDocuments from './pages/projects/tabs/Documents'
import ProjectServices from './pages/projects/tabs/Services'
import ProjectTimeLogs from './pages/projects/tabs/TimeLogs'
import ProjectChangeOrders from './pages/projects/tabs/ChangeOrders'
import ProjectJobCosting from './pages/projects/tabs/JobCosting'

// Tasks
import Tasks from './pages/tasks/Index'
import CreateTask from './pages/tasks/Create'
import ShowTask from './pages/tasks/Show'
// import EditTask from './pages/tasks/Edit'

// Proposals
import Proposals from './pages/proposals/Index'
import CreateProposal from './pages/proposals/Create'
import ShowProposal from './pages/proposals/Show'
import ProposalMilestones from './pages/proposals/show/Milestones'
import ProposalNotes from './pages/proposals/show/Notes'
import ProposalFiles from './pages/proposals/show/Files'
import EditProposal from './pages/proposals/Edit'
import CloneProposal from './pages/proposals/Clone'

// Lead Center
import Leads from './pages/leads/Index'

// Services
import Services from './pages/services/Index'
import CreateService from './pages/services/Create'
import EditService from './pages/services/Edit'

// Reminders
import Reminders from './pages/reminders/Index'
import CreateReminder from './pages/reminders/Create'
import ShowReminder from './pages/reminders/Show'
import EditReminder from './pages/reminders/Edit'

// Time Logs
import TimeLogs from './pages/time-logs/Index'
import CreateTimeLog from './pages/time-logs/Create'
import ShowTimeLog from './pages/time-logs/Show'
import EditTimeLog from './pages/time-logs/Edit'

// Change Orders
import CreateChangeOrder from './pages/change-orders/Create'
import ShowChangeOrder from './pages/change-orders/Show'
import EditChangeOrder from './pages/change-orders/Edit'

// Dob permit types
import DobPermitTypes from './pages/dob-permit-types/Index'

// Dot permit types
import DotPermitTypes from './pages/dot-permit-types/Index'

// Job work types
import WorkTypes from './pages/work-types/Index'

// Inspection service types
import InspectionServiceTypes from './pages/inspection-service-types/Index'

// Audit logs
import AuditLogs from './pages/audit-logs/Index'

// Correspondence filtering
import CorrespondenceFiltering from './pages/correspondence-filtering/Index'

// Universal documents
import UniversalDocuments from './pages/universal-documents/Index'

// Global settings
import GlobalSettings from './pages/global-settings/Index'

import GeneralSettings from './pages/settings/General'

import Redirect from './pages/Redirect'

import AllNotifications from './pages/AllNotifications'

import NotificationSettings from './pages/NotificationSettings'

// Reports

import Reports from './pages/reports/Index.vue'
import PendingApproved from './pages/reports/PendingApproved.vue'
import Referrals from './pages/reports/Referrals.vue'
import BillingSummary from "./pages/reports/BillingSummary.vue";
import PendingChangeOrders from "./pages/reports/PendingChangeOrders.vue";

const routes =  [
    {
        path: '/redirect',
        component: Redirect,
    },
    {
        path: '/',
        alias: '/login',
        component: Login,
        name: 'login',
        meta: {
            guestRoute: true
        }
    },
    {
        path: '/send-reset-password-link',
        component: SendResetPasswordLink,
        name: 'send-reset-password-link',
        meta: {
            guestRoute: true
        }
    },
    {
        path: '/password/reset/:token',
        component: ResetPassword,
        name: 'reset-password',
        meta: {
            guestRoute: true
        }
    },
    {
        path: '/dashboard',
        name: 'dashboard',
        component: DashboardLayout,
        children: [
            {
                path: '',
                component: Dashboard,
                children: [
                    {
                        name: 'home',
                        path: '',
                        component: ProposalDashboard,
                    },
                    {
                        path: 'proposals',
                        name: 'dashboard.proposals',
                        component: ProposalDashboard,
                    },
                    // {
                    //     path: 'projects',
                    //     name: 'dashboard.projects',
                    //     component: ProjectDashboard,
                    // },
                    // {
                    //     path: 'expirations',
                    //     name: 'dashboard.expirations',
                    //     component: ExpirationDashboard,
                    // },
                    {
                        path: 'billing',
                        name: 'dashboard.billing',
                        component: BillingDashboard,
                    },
                    {
                        path: 'job-costing',
                        name: 'dashboard.job-costing',
                        component: JobCostingDashboard,
                    },
                    {
                        path: 'production-planning',
                        name: 'dashboard.production-planning',
                        component: ProductionReport,
                    },
                    {
                        path: 'services-overview',
                        name: 'dashboard.services-overview',
                        component: ServicesOverviewReport,
                    },
                    {
                        path: 'tasks-by-location',
                        name: 'dashboard.tasks-by-location',
                        component: TasksByLocation
                    },
                    {
                        path: 'service-level',
                        name: 'dashboard.service-level',
                        component: ServiceLevelReport,
                    },
                ]
            },
            {
                name: 'emails',
                path: '/emails/:label?',
                component: Emails,
                children: [
                    {
                        name: 'emails.view',
                        path: 'view/:message_id/:selected_id?',
                        component: ShowMail,
                    },
                ],
            },
            {
                name: 'emails.login',
                path: '/emails/login',
                component: EmailsLogin,
            },
            {
                name: 'emails-test',
                path: '/emails-test',
                component: EmailsTest,
                children: [
                    {
                        name: 'emails-test.view',
                        path: 'view/:message_id/',
                        component: ShowMailTest,
                    },
                ],
            },
            {
                path: '/slack',
                name: 'slack',
                component: Slack,
                children: [
                    {
                        name: 'slack.channel',
                        path: 'channel/:id',
                        component: SlackChannel,
                    },
                    {
                        name: 'slack.saveditems',
                        path: 'saved-items',
                        component: SavedItemsPage,
                    }
                ],
            },
            {
                path: '/teams',
                name: 'teams.index',
                component: Teams,

            },
            {
                path: '/users',
                name: 'users.index',
                component: Users,
                meta: { requiresPermission: "users.index"}
            },
            {
                path: '/users/new',
                name: 'users.create',
                component: CreateUser,
                meta: { requiresPermission: "users.create" }
            },
            {
                path: '/users/:slug',
                name: 'users.show',
                component: ShowUser,
                meta: { requiresPermission: "users.show"}

            },
            {
                path: '/users/:slug/edit',
                name: 'users.edit',
                component: EditUser,
                meta: { requiresPermission: "users.update"}
            },
            {
                path: '/roles',
                name: 'roles.index',
                component: Roles,
                meta: { requiresPermission: "roles.index"}
            },
            {
                path: '/roles/new',
                name: 'roles.create',
                component: CreateRole,
                meta: { requiresPermission: "roles.create"}
            },
            {
                path: '/roles/:slug',
                name: 'roles.show',
                component: ShowRole,
                meta: { requiresPermission: "roles.show"}

            },
            {
                path: '/roles/:slug/edit',
                name: 'roles.edit',
                component: EditRole,
                meta: { requiresPermission: "roles.update"}

            },
            {
                path: '/-emails-',
                name: 'emails-',
                component: PageEmails,
                meta: { requiresPermission: "'emails.index"}
            },
            {
                path: '/user-settings',
                name: 'user-settings',
                component: UserSettings,
            },
            {
                path: '/companies',
                name: 'companies.index',
                component: Companies,
                meta: { requiresPermission: "companies.index"}
            },
            {
                path: '/companies/new',
                name: 'companies.create',
                component: CreateCompany,
                meta: { requiresPermission: "companies.create"}
            },
            {
                path: '/companies/:slug',
                name: 'companies.show',
                component: ShowCompany,
                meta: { requiresPermission: "companies.show"}
            },
            {
                path: '/companies/:slug/edit',
                name: 'companies.edit',
                component: EditCompany,
                meta: { requiresPermission: "companies.update"}
            },
            {
                path: '/projects',
                name: 'projects.index',
                component: Projects,
                meta: { requiresPermission: "projects.index"}
            },
            {
                path: '/projects/:slug/',
                component: ShowProject,
                children: [
                    {
                        path: '',
                        alias: 'services',
                        name: 'projects.show',
                        component: ProjectServices
                    },
                    {
                        path: 'activities',
                        name: 'projects.show.activities',
                        component: ProjectActivities
                    },
                    {
                        path: 'emails',
                        name: 'projects.show.emails',
                        component: ReferenceEmails
                    },
                    {
                        path: 'tasks',
                        name: 'projects.show.tasks',
                        component: ProjectTasks
                    },
                    {
                        path: 'contacts',
                        name: 'projects.show.contacts',
                        component: ProjectContacts
                    },
                    {
                        path: 'tasks/:id',
                        name: 'projects.show.tasks.show',
                        component: ShowTask
                    },
                    {
                        path: 'applications',
                        name: 'projects.show.applications',
                        component: ProjectApplications,
                        props: true
                    },
                    {
                        path: 'applications/:tabParam',
                        name: 'projects.show.applications.tab',
                        component: ProjectApplications,
                        props: true
                    },
                    {
                        path: 'applications/:applicationTypeParam/:applicationIdParam',
                        name: 'projects.show.applications.type',
                        component: ProjectApplications,
                        props: true
                    },
                    {
                        path: 'notes',
                        name: 'projects.show.notes',
                        component: ProjectNotes
                    },
                    {
                        path: 'correspondence',
                        name: 'projects.show.correspondence',
                        component: ProjectCorrespondence
                    },
                    {
                        path: 'documents',
                        name: 'projects.show.documents',
                        component: ProjectDocuments
                    },
                    {
                        path: 'services',
                        name: 'projects.show.services',
                        component: ProjectServices
                    },
                    {
                        path: 'time-logs',
                        name: 'projects.show.time-logs',
                        component: ProjectTimeLogs
                    },
                    {
                        path: 'change-orders',
                        name: 'projects.show.change-orders',
                        component: ProjectChangeOrders,
                        requiresPermission: "change-orders.create"
                    },
                    {
                        path: 'job-costing',
                        name: 'projects.show.job-costing',
                        component: ProjectJobCosting
                    }
                ],
                meta: { requiresPermission: "projects.show"}
            },
            {
                path: '/projects/:slug/edit',
                name: 'projects.edit',
                component: EditProject,
                meta: { requiresPermission: "projects.update"}
            },
            {
                path: '/tasks',
                name: 'tasks.index',
                component: Tasks,
                meta: { requiresPermission: "tasks.index"}
            },
            {
                path: '/tasks/new',
                name: 'tasks.create',
                component: CreateTask,
                meta: { requiresPermission: "tasks.create"}
            },
            {
                path: '/tasks/:slug',
                name: 'tasks.show',
                component: ShowTask,
                meta: { requiresPermission: "tasks.show"}
            },
            {
                path: '/proposals',
                name: 'proposals.index',
                component: Proposals,
                meta: { requiresPermission: "proposals.index"}
            },
            {
                path: '/proposals/new',
                name: 'proposals.create',
                component: CreateProposal,
                meta: { requiresPermission: "proposals.create"}
            },
            {
                path: '/proposals/:slug',
                component: ShowProposal,
                meta: { requiresPermission: "proposals.show"},
                children: [
                    {
                        path: '',
                        name: 'proposals.show',
                        component: ProposalMilestones
                    },
                    {
                        path: 'milestones',
                        name: 'proposals.show.milestones',
                        component: ProposalMilestones
                    },
                    {
                        path: 'emails',
                        name: 'proposals.show.emails',
                        component: ReferenceEmails,
                    },
                    {
                        path: 'notes',
                        name: 'proposals.show.notes',
                        component: ProposalNotes
                    },
                    {
                        path: 'files',
                        name: 'proposals.show.files',
                        component: ProposalFiles
                    },
                ]
            },
            {
                path: '/proposals/:slug/edit',
                name: 'proposals.edit',
                component: EditProposal,
                meta: { requiresPermission: "proposals.update"}
            },
            {
                path: '/proposals/:slug/clone',
                name: 'proposals.clone',
                component: CloneProposal,
                meta: { requiresPermission: "proposals.update"}
            },
            {
                path: '/leads',
                name: 'leads.index',
                component: Leads
            },
            {
                path: '/services',
                name: 'services.index',
                component: Services,
                meta: { requiresPermission: "services.index"}
            },
            {
                path: '/services/new',
                name: 'services.create',
                component: CreateService,
                meta: { requiresPermission: "services.create"}
            },
            {
                path: '/services/:slug/edit',
                name: 'services.edit',
                component: EditService,
                meta: { requiresPermission: "services.update"}
            },
            {
                path: '/reminders',
                name: 'reminders.index',
                component: Reminders,
                meta: { requiresPermission: "reminders.index"}
            },
            {
                path: '/reminders/new',
                name: 'reminders.create',
                component: CreateReminder,
                meta: { requiresPermission: "reminders.create"}
            },
            {
                path: '/reminders/:slug',
                name: 'reminders.show',
                component: ShowReminder,
                meta: { requiresPermission: "reminders.show"}
            },
            {
                path: '/reminders/:slug/edit',
                name: 'reminders.edit',
                component: EditReminder,
                meta: { requiresPermission: "reminders.update"}
            },
            {
                path: '/time-logs',
                name: 'time-logs.index',
                component: TimeLogs,
                meta: { requiresPermission: "time-logs.index"}
            },
            {
                path: '/time-logs/new',
                name: 'time-logs.create',
                component: CreateTimeLog,
                meta: { requiresPermission: "time-logs.create"}
            },
            {
                path: '/time-logs/:slug',
                name: 'time-logs.show',
                component: ShowTimeLog,
                meta: { requiresPermission: "time-logs.show"}
            },
            {
                path: '/time-logs/:slug/edit',
                name: 'time-logs.edit',
                component: EditTimeLog,
                meta: { requiresPermission: "time-logs.update"}
            },
            {
                path: '/change-orders/new',
                name: 'change-orders.create',
                component: CreateChangeOrder,
                meta: { requiresPermission: "project_change_orders.create"}
            },
            {
                path: '/change-orders/:slug',
                name: 'change-orders.show',
                component: ShowChangeOrder,
                meta: { requiresPermission: "project_change_orders.show"}
            },
            {
                path: '/change-orders/:slug/edit',
                name: 'change-orders.edit',
                component: EditChangeOrder,
                meta: { requiresPermission: "project_change_orders.update"}
            },
            {
                path: '/dob-permit-types',
                name: 'dob-permit-types.index',
                component: DobPermitTypes
            },
            {
                path: '/dot-permit-types',
                name: 'dot-permit-types.index',
                component: DotPermitTypes
            },
            {
                path: '/job-work-types',
                name: 'job-work-types.index',
                component: WorkTypes,
                meta: {
                    type: 'job'
                }
            },
            {
                path: '/service-work-types',
                name: 'service-work-types.index',
                component: WorkTypes,
                meta: {
                    type: 'service'
                }
            },
            {
                path: '/inspection-service-types',
                name: 'inspection-service-types.index',
                component: InspectionServiceTypes
            },
            {
                path: '/audit-log',
                name: 'audit-logs.index',
                component: AuditLogs
            },
            {
                path: '/correspondence-filtering',
                name: 'correspondence-filtering.index',
                component: CorrespondenceFiltering
            },
            {
                path: '/universal-documents',
                name: 'universal-documents.index',
                component: UniversalDocuments
            },
            {
                path: '/global-settings',
                name: 'global-settings.index',
                component: GlobalSettings
            },
            {
                path: '/general-settings',
                name: 'settings.general',
                component: GeneralSettings
            },
            {
                path: '/notifications',
                name: 'notifications',
                component: AllNotifications
            },
            {
                path: '/notifications-settings',
                name: 'notification-settings',
                component: NotificationSettings
            },
            {
                path: '/reports-list',
                name: 'reports.list',
                component: Reports
            },
            {
                path: '/pending-approved',
                name: 'reports.pending-approved',
                component: PendingApproved
            },
            {
                path: '/referrals',
                name: 'reports.referrals',
                component: Referrals
            },
            {
                path: '/billing-summary',
                name: 'reports.billing-summary',
                component: BillingSummary
            },
            {
                path: '/pending-changer-orders',
                name: 'reports.pending-change-orders',
                component: PendingChangeOrders
            },
        ],
    },
    {
        path: '/:pathMatch(.*)',
        name: 'NotFound',
        component: NotFound
    }
]

export default routes
